import httpService from "./httpService";
import utils from "./utils";

export default {

  findAll(example, pagable) {
    pagable = utils.initPageableParams(pagable);
    let params = utils.merge(example, pagable);
    return httpService.get("/outgoingDocReceivers", {params: params});
  },
  findAllIn(ids) {
    return httpService.get(`/outgoingDocReceivers/findAllIn`,{params:{ids:ids}});
  },
}



// WEBPACK FOOTER //
// ./src/services/outgoingDocReceiversService.js